export default "__VITE_ASSET__BFNWHdYZ__"